import React from "react";

interface TableFiltersNavButtonsProps {
   activeTab: number;
   setActiveTab: (tabIndex: number) => void;
}

const TableFiltersNavButtons: React.FC<TableFiltersNavButtonsProps> = ({
   activeTab,
   setActiveTab
}) => {
   return (
      <>
         <button
            onClick={() => setActiveTab(1)}
            className={`table-nav-filters-button left-button ${activeTab === 1 ? "active" : ""}`}
         >
            Filtry
         </button>
         <button
            onClick={() => setActiveTab(2)}
            className={`table-nav-filters-button right-button ${activeTab === 2 ? "active" : ""}`}
         >
            Grupy
         </button>
      </>
   );
};

export default TableFiltersNavButtons;
